import { Grid2X2, List } from 'lucide-react';

export default function ViewToggle({ value = 'grid', onChange }) {
  const options = [
    { value: 'grid', label: 'Grid view', Icon: Grid2X2 },
    { value: 'list', label: 'List view', Icon: List },
  ];

  return (
    <div
      role="group"
      aria-label="View layout"
      className="
        relative inline-flex shrink-0 rounded-xl
        border border-neutral-700 bg-neutral-900 p-1
      "
    >
      {/* Sliding highlight */}
      <div
        aria-hidden="true"
        className={`
          pointer-events-none absolute bottom-1 left-1 top-1
          w-10 rounded-lg bg-neutral-700 shadow-sm
          transition-transform duration-300 ease-out
          motion-reduce:transition-none
          ${value === 'list' ? 'translate-x-10' : 'translate-x-0'}
        `}
      />

      {options.map(({ value: optionValue, label, Icon }) => {
        const isSelected = value === optionValue;

        return (
          <button
            key={optionValue}
            type="button"
            title={label}
            aria-label={label}
            aria-pressed={isSelected}
            onClick={() => onChange?.(optionValue)}
            className={`
              relative z-10 flex h-10 w-10 items-center justify-center
              rounded-lg transition-colors duration-200
              focus-visible:outline-none focus-visible:ring-2
              focus-visible:ring-neutral-400 focus-visible:ring-offset-2
              focus-visible:ring-offset-neutral-900
              motion-reduce:transition-none
              ${
                isSelected
                  ? 'text-neutral-100'
                  : 'text-neutral-500 hover:text-neutral-200'
              }
            `}
          >
            <Icon size={19} strokeWidth={2} aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
